/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ECourseLangFileType } from "../types/ECourseLangFileType.ts";

/**
 * @description 1 = Manual | 2 = Regiment | 3 = UspDocument |
 */
export const eCourseLangFileTypeSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3)])
  .describe(
    "1 = Manual | 2 = Regiment | 3 = UspDocument | ",
  ) as unknown as ToZod<ECourseLangFileType>;
